let show3dPreview: boolean | undefined = undefined;

// All supported browsers have webgl support, however it may be disabled by the user
// or unavailable due to a bug in the browser
export const canShow3dPreview = () => {

    if (process.env.REACT_APP_TO_BUILD === 'website-server') {
        return false;
    }

    if (show3dPreview === undefined) {
        show3dPreview = detectWebGLContext();
    }

    return show3dPreview;
};

// Based on: https://developer.mozilla.org/en-US/docs/Web/API/WebGL_API/By_example/Detect_WebGL
const detectWebGLContext = () => {
    const canvas = document.createElement('canvas');
    const ctx = canvas.getContext('webgl') || canvas.getContext('experimental-webgl');
    return ctx instanceof WebGLRenderingContext;
};